import { QuestBehavior } from './quest-behavior.interface';

export class QuestConfig {
    /**
     * Context for translations - will be used as prefix for all identifiers
     */
    context?: string;

    /**
     * Icon names used for:
     * - valid/invalid indicators (default check/cancel)
     * - file question (description default)
     * - enable / disable validation icons (default enabled)
     */
    icons?: {
        valid?: string;
        invalid?: string;
        file?: string;
        enabled?: boolean;
    };

    /**
     * Behavior settings
     */
    behavior?: QuestBehavior;

    /**
     * File handling config
     */
    file?: {
        uploadUrl?: string;
        csrfTokenLocalStorageKey?: string;
    };
    /**
     * hint settings
     * useDialog: max screen size in px upto which hint is show as matDialog, default 1083
     * hintOnMouseOver: for desktop view (screen size > useDialog screen size) show hint onMouseOver instead of click,
     * default: false
     */
    hint?: {
        useDialog?: number;
        hintOnMouseOver?: boolean;
    };
}
